<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Partner Contract Info
    </div>
    <div class="enterprise-network_container_content">
      <el-row style="row-gap: 40px">
        <el-col class="enterprise-network_mb-40" :span="12">
          <div class="enterprise-network_label">Partner Type</div>
          <div class="enterprise-network_value">
            {{ formData['partnerTypeName'] || '-' }}
          </div>
        </el-col>
        <el-col class="enterprise-network_mb-40" :span="12" v-if="isEBG && !(partnerType === 'RCP')">
          <div class="enterprise-network_label">Party A of the Signing Agreement</div>
          <div class="enterprise-network_value">
            {{ formData['signingAgreementPartyA'] || '-' }}
          </div>
        </el-col>
        <el-col class="enterprise-network_mb-40" :span="12" v-if="!isEBG">
          <div class="enterprise-network_label">Contract Expiry Date</div>
          <div class="enterprise-network_value">
            {{ formData['contractValidity'] || '-' }}
          </div>
        </el-col>
        <template>
          <el-col class="enterprise-network_mb-40" :span="12" v-if="isEBG && !(partnerType === 'RCP')">
            <div class="enterprise-network_label">Partner Payment Terms</div>
            <div class="enterprise-network_value">
              {{ getPartnerPaymentTerms(formData.partnerPaymentTerms) || '-' }}
            </div>
          </el-col>
          <el-col class="enterprise-network_mb-40" :span="12" v-if="isEBG || (partnerType === 'RCP')">
            <div class="enterprise-network_label">Contract Start Date</div>
            <div class="enterprise-network_value">
              {{ formData['contractStartDate'] || '-' }}
            </div>
          </el-col>

          <el-col class="enterprise-network_mb-40" :span="12" v-if="isEBG || (partnerType === 'RCP')">
            <div class="enterprise-network_label">Contract Expiry Date</div>
            <div class="enterprise-network_value">
              {{ formData['contractValidity'] || '-' }}
            </div>
          </el-col>
        </template>
        <el-col class="enterprise-network_mb-40" :span="12" v-if="['RGP','RSP','RCP'].includes(partnerType)">
          <div class="enterprise-network_label">Affiliated RAD</div>
          <div class="enterprise-network_value">
            {{ formData['parentCompanyName'] || '-' }}
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "enterpriseNetworkPartnerContractInfoDetail",
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    isEBG: {
      type: Boolean,
      default: false
    },
    isShowVadSelect: {
      type: Boolean,
      default: false
    },
    partnerType: {
      type: String,
      default: ''
    }
  },
  methods: {
    getPartnerPaymentTerms(type) {
      if (Number(type) === 0) {
        return 'Cash'
      }
      if (Number(type) === 1) {
        return 'Credit'
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/partnerContractInfo/partnerContractInfoDetail.vue